<script>
import cloneDeep from 'lodash/cloneDeep'
import { memberDetailsComputed } from '@state/helpers/member-details'
import { GENDER } from '@utils/constant'
import differenceInCalendarYears from 'date-fns/differenceInCalendarYears'
import basicInfoItems from './basicInfoItems'

export default {
  props: {
    triggerMask: {
      type: Boolean,
      require: false,
    },
  },
  data() {
    return {
      items: cloneDeep(basicInfoItems),
      url: '',
    }
  },
  computed: {
    ...memberDetailsComputed,
    itemsComputed() {
      if (this.getDetails) {
        const details = cloneDeep(this.getDetails)
        return this.items?.map((item) => {
          switch (item.key) {
            case 'birthday':
              item.value =
                differenceInCalendarYears(
                  new Date(),
                  new Date(details[item.key])
                ) +
                '歳(' +
                details[item.key] +
                ')'
              break
            case 'gender':
              item.value = GENDER[details[item.key]]
              break
            case 'height':
              item.value = details[item.key] + ' cm'
              break
            case 'goal_weight':
              details[item.key] === 0
                ? (item.value = '')
                : (item.value = details[item.key] + ' kg')
              break
            case 'athlete':
              details[item.key] === 1
                ? (item.value = 'on')
                : (item.value = 'off')
              break
            default:
              item.value = details[item.key]
              break
          }
          return item
        })
      }
      return this.items
    },
    photoComputed() {
      const photo = this.getDetails?.photo
      const gender = this.getDetails?.gender
      if (photo !== '') return 0
      if (gender === 0) return 1
      return 2
    },
    urlAvatarComputed() {
      if (this.getDetails?.photo) {
        return `${process.env.VUE_APP_API_BASE_URL}/${this.getDetails.photo}`
      }
      return ''
    },
  },
}
</script>

<template>
  <div id="member-details-basic-info">
    <BaseCardDetail title="基本情報" form-collapsed :trigger-mask="triggerMask">
      <template v-slot:header-action>
        <div />
      </template>
      <CRow
        v-for="item in itemsComputed"
        :key="item.key"
        class="border border-bottom-0 border-left-0 border-right-0 py-2 mx-1 d-flex align-items-center"
      >
        <template v-if="item.key === 'account_name'">
          <CCol sm="5">{{ item.label }}</CCol>
          <CCol sm="5" class="feeline-color-content">{{ item.value }}</CCol>
          <CCol sm="2">
            <CImg
              v-if="photoComputed === 0"
              shape="rounded-circle"
              height="40px"
              width="40px"
              :src="urlAvatarComputed"
              alt=""
            />
            <CImg
              v-else-if="photoComputed === 1"
              shape="rounded-circle"
              height="40px"
              width="40px"
              :src="require('@assets/images/female.png')"
            />
            <CImg
              v-else
              shape="rounded-circle"
              height="40px"
              width="40px"
              :src="require('@assets/images/male.png')"
            />
          </CCol>
        </template>
        <template v-else>
          <CCol sm="5">{{ item.label }}</CCol>
          <CCol sm="7" class="feeline-color-content">{{ item.value }}</CCol>
        </template>
      </CRow>
    </BaseCardDetail>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .feeline-color-content {
  color: $gray-900;
}
</style>
